import {
  BarChart3Icon,
  MegaphoneIcon,
  UsersIcon,
  Activity as ActivityIcon,
  CreditCardIcon,
  HeadphonesIcon,
  type LucideIcon,
} from 'lucide-react'

export type Integration = { name: string; abbr: string }

export type IntegrationCategory = {
  id: string
  label: string
  icon: LucideIcon
  items: Integration[]
}

export const integrationCategories: IntegrationCategory[] = [
  {
    id: 'analytics',
    label: 'Analytics',
    icon: BarChart3Icon,
    items: [
      { name: 'Google Analytics 4', abbr: 'GA4' },
      { name: 'Mixpanel', abbr: 'MP' },
      { name: 'Amplitude', abbr: 'AM' },
      { name: 'Segment', abbr: 'Sg' },
    ],
  },
  {
    id: 'ads',
    label: 'Advertising',
    icon: MegaphoneIcon,
    items: [
      { name: 'Google Ads', abbr: 'GA' },
      { name: 'Meta Ads', abbr: 'Me' },
      { name: 'LinkedIn Ads', abbr: 'Li' },
      { name: 'TikTok Ads', abbr: 'Tk' },
    ],
  },
  {
    id: 'crm',
    label: 'CRM & Sales',
    icon: UsersIcon,
    items: [
      { name: 'HubSpot', abbr: 'Hs' },
      { name: 'Salesforce', abbr: 'Sf' },
      { name: 'Pipedrive', abbr: 'Pd' },
      { name: 'Marketo', abbr: 'Mk' },
    ],
  },
  {
    id: 'product',
    label: 'Product & Data',
    icon: ActivityIcon,
    items: [
      { name: 'Snowflake', abbr: 'Sn' },
      { name: 'Slack', abbr: 'Sl' },
      { name: 'Segment', abbr: 'Sg' },
      { name: 'Webhooks', abbr: 'Wh' },
    ],
  },
  {
    id: 'payments',
    label: 'Payments',
    icon: CreditCardIcon,
    items: [
      { name: 'Stripe', abbr: 'St' },
      { name: 'Chargebee', abbr: 'Cb' },
      { name: 'Paddle', abbr: 'Pa' },
      { name: 'QuickBooks', abbr: 'Qb' },
    ],
  },
  {
    id: 'support',
    label: 'Support',
    icon: HeadphonesIcon,
    items: [
      { name: 'Intercom', abbr: 'Ic' },
      { name: 'Zendesk', abbr: 'Zd' },
      { name: 'Front', abbr: 'Fr' },
      { name: 'Drift', abbr: 'Dr' },
    ],
  },
]

export const heroLogos = [
  'HubSpot',
  'GA4',
  'Google Ads',
  'Meta Ads',
  'Salesforce',
  'Segment',
  'Stripe',
  'Mixpanel',
]
